import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { BndesUx4 } from '@bndes/bndes-ux4';
import { BnFormValidationModule } from "@bndes/bndes-ux4";
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { SERVICES_CONST } from './services';
import { LoggerService } from './services/logger.service';
import { ConsoleLoggerService } from './services/console-logger.service';

@NgModule({
  imports: [
    HttpClientModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgbModule,
    BndesUx4.forRoot({ 'baseUrl': '.' , 'loginUrl': '/rest/public/a03/user/auth', baseA03Url: '/a03' }),
    BnFormValidationModule.forRoot(),

  ],
  declarations: [],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgbModule,
    BndesUx4,
    BnFormValidationModule
  ],
  providers: [
    CookieService,
    HttpClient,
    ...SERVICES_CONST,
    DatePipe,
    { provide: LoggerService, useClass: ConsoleLoggerService }    
  ]
})
export class SharedModule { }
